// extracted by mini-css-extract-plugin
export default {"topCont":"DetailsCard_topCont__RWJvM","title":"DetailsCard_title__qXSyZ","title2":"DetailsCard_title2__IFuKm","cont":"DetailsCard_cont__cqEwX","text":"DetailsCard_text__dRBdg"};